import transitionend from "../../util/transitionend";
import {
    disableBodyScroll,
    enableBodyScroll,
    clearAllBodyScrollLocks
} from "body-scroll-lock";

function Menu(opt) {

    var options = {
            button: '.menu-button',
            nav: '.js.nav',
            button_container: '.header',
            menu_icon: '.menu-icon',
            menu_text: '.menu-text',
        },
        obj = {},
        body = document.querySelector('body');

    if (typeof opt === "object") {
        extendDefaults(options, opt);
    }

    init();

    function init() {
        obj.menuButton = document.querySelector(options.button);
        obj.menuButtonContainer = document.querySelector(options.button_container);
        obj.nav = document.querySelector(options.nav);

        if (obj.nav != null) {
            obj.nav.addEventListener('click', function (e) {
                e.stopPropagation();
            });
            obj.menuButton.addEventListener('click', button__click);
        }
    }

    function button__click(e) {
        e.stopPropagation();
        obj.menuButton.classList.toggle('is-menu-open');
        obj.menuButtonContainer.classList.toggle('is-menu-open');
        obj.nav.classList.toggle('is-open');
        body.classList.toggle('is-menu-open');

        var menuIcon = document.querySelector(options.menu_icon);
        var menuText = document.querySelector(options.menu_text);

        if (obj.nav.classList.contains("is-open")) {
            disableBodyScroll(obj.nav);

            menuIcon.classList.remove('fa-bars');
            menuIcon.classList.remove('fal');
            menuIcon.classList.add('fa-times');
            menuIcon.classList.add('fas');
            menuText.innerHTML = 'Close';
        } else {
            enableBodyScroll(obj.nav);

            menuIcon.classList.add('fa-bars');
            menuIcon.classList.add('fal');
            menuIcon.classList.remove('fa-times');
            menuIcon.classList.remove('fas');
            menuText.innerHTML = 'Menu';
        }

        obj.nav.addEventListener(transitionend, function() {
            document.addEventListener('click', body__click);
        });
    }

    function body__click(e) {
        obj.menuButton.classList.remove('is-menu-open');
        obj.menuButtonContainer.classList.toggle('is-menu-open');
        obj.nav.classList.remove('is-open');
        body.classList.remove('is-menu-open');

        document.removeEventListener('click', body__click);
    }

    function extendDefaults(src, prop) {
        var property;
        for (property in prop) {
            if (prop.hasOwnProperty(property)) {
                src[property] = prop[property];
            }
        }
    }
}

export default Menu;



// WEBPACK FOOTER //
// ./js/components/menu/index.js